<script setup lang="ts">
import { onMounted, watch } from "vue"
import { RouterView } from "vue-router"
import { useI18n } from "vue-i18n"
import { usePreferences } from "@/stores/preferences"
import { useAuth } from "@/stores/auth"
import Modal from "@/components/ui/Modal.vue"
import PanelSlideOver from "@/components/ui/PanelSlideOver.vue"
import RaidStormIdle from "@/components/utils/RaidStormIdle.vue"

const { locale } = useI18n()
const useAuthStore = useAuth()
const usePreferencesStore = usePreferences()
const currentLanguage = () => usePreferencesStore.language

const onIdle = () => {
  useAuthStore.logout()
}

watch(currentLanguage, () => {
  locale.value = currentLanguage()
})

onMounted(() => {
  window.addEventListener("storage", event => {
    if (event.key === "tenant-changed") {
      const value = localStorage.getItem("tenant-changed")
      if (value === "true") {
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      }
    }
  })
  localStorage.removeItem("tenant-changed")
})
</script>

<template>
  <div>
    <RaidStormIdle
      class="hidden"
      :wait="0"
      :events="['mousemove', 'keydown', 'mousedown', 'touchstart']"
      :duration="3600"
      @idle="onIdle"
    />
    <Teleport to="#modal">
      <Modal />
    </Teleport>
    <Teleport to="#slide-over">
      <PanelSlideOver />
    </Teleport>

    <RouterView />
  </div>
</template>
